export const OAMN = "62a8815e42be6e0012bda012";
export const DOGU = "5ebe682fb308810011922d13";
